<div id="{{ title }}">
  <router-outlet></router-outlet>
  <!-- <button class="updateversion" type="button" (click)="update()">
    Version Update
  </button> -->
</div>
